/* eslint-disable no-empty, no-redeclare, no-unused-vars */

import { $ as jquery } from 'jquery';
import { i18n } from '../core/i18n.js';
import { laydate } from './laydate.js';
import { form } from './form.js';
import { upload } from './upload.js';
import { laypage } from './laypage.js';
import { layer } from './layer.js';
import { createMediaCategoryTree } from './mediaCategoryTree.js';
import { getMediaManageLayerOptions, getMediaDialogFormOptions, createMediaFormFieldHtml, createMediaConfirmHtml, createMediaMobileBar, bindMediaMobilePanels, createMediaSelectionHelper, createMediaDialogFooter, bindMediaDialogFooter } from './mediaManageResponsive.js';

var $ = jquery;
var Fancybox = window.layui && window.layui.fancybox ? window.layui.fancybox : window.Fancybox;
	var trimText = function(value){
		return value == null ? '' : String(value).trim();
	};
	var escapeHtml = function(value){
		return String(value == null ? '' : value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	};
	i18n.set({
		messages: {
			'zh-CN': {
				videoManage: {
					addGroup: '添加分组',
					allVideos: '所有视频',
					dateRange: '日期范围',
					fileName: '文件名',
					search: '搜索',
					delete: '删除',
					move: '移动',
					uploadVideo: '上传视频',
					selectAllPage: '本页全选',
					selectedCount: '已选 {count} 个',
					selectGroup: '选择分组',
					moveVideo: '移动视频',
					moveSuccess: '移动成功',
					moveFailed: '移动失败',
					selectVideoToMove: '请选择要移动的视频?',
					deleteVideo: '删除视频',
					confirmDeleteVideos: '真的要删除选择的视频吗?',
					deleteSuccess: '删除成功',
					deleteFailed: '删除失败',
					selectVideoToDelete: '请选择要删除的视频?',
					maxSelect: '最多只能选{max}个',
					renameFile: '修改文件名【{name}】',
					fileNameLabel: '文件名',
					renameSuccess: '修改成功',
					renameFailed: '修改失败',
					fileNameRequired: '文件名不能为空',
					newGroup: '新建分组',
					groupName: '分组名称',
					groupNameRequired: '请填写分组名称',
					groupCancel: '取消',
					edit: '修改',
					deleteGroup: '删除分组',
					confirmDeleteGroup: '真的要删除该分组吗?',
					deleteGroupWithChildren: '请先删除子分组',
					selectVideo: '选择视频',
					confirm: '确定',
					cancel: '取消'
				}
			},
			'en-US': {
				videoManage: {
					addGroup: 'Add Group',
					allVideos: 'All Videos',
					dateRange: 'Date Range',
					fileName: 'File Name',
					search: 'Search',
					delete: 'Delete',
					move: 'Move',
					uploadVideo: 'Upload Video',
					selectAllPage: 'Select all on page',
					selectedCount: 'Selected {count}',
					selectGroup: 'Select Group',
					moveVideo: 'Move Video',
					moveSuccess: 'Moved successfully',
					moveFailed: 'Move failed',
					selectVideoToMove: 'Please select video(s) to move.',
					deleteVideo: 'Delete Video',
					confirmDeleteVideos: 'Are you sure you want to delete the selected videos?',
					deleteSuccess: 'Deleted successfully',
					deleteFailed: 'Delete failed',
					selectVideoToDelete: 'Please select video(s) to delete.',
					maxSelect: 'You can select up to {max} items',
					renameFile: 'Rename File [{name}]',
					fileNameLabel: 'File Name',
					renameSuccess: 'Renamed successfully',
					renameFailed: 'Rename failed',
					fileNameRequired: 'File name is required',
					newGroup: 'New Group',
					groupName: 'Group Name',
					groupNameRequired: 'Please enter a group name',
					groupCancel: 'Cancel',
					edit: 'Edit',
					deleteGroup: 'Delete Group',
					confirmDeleteGroup: 'Are you sure you want to delete this group?',
					deleteGroupWithChildren: 'Please delete child groups first',
					selectVideo: 'Select Video',
					confirm: 'Confirm',
					cancel: 'Cancel'
				}
			}
		}
	});
	var t = function(key, fallback, params){
		return i18n.translate('videoManage.' + key, params, { default: fallback });
	};

	var openVideoPreview = function(src){
		if(!src){
			return;
		}
		var safeSrc = escapeHtml(src);
		var viewportWidth = Math.max($(window).width() - 32, 280);
		var width = Math.min(viewportWidth, 960);
		layer.open({
			type: 1,
			title: false,
			closeBtn: 1,
			shadeClose: true,
			resize: false,
			scrollbar: false,
			skin: 'layui-layer-g3ys-form media-preview-layer media-preview-layer-video',
			area: [width + 'px', 'auto'],
			content: "<div class='media-preview-wrap media-preview-video-wrap'><video src='" + safeSrc + "' controls='controls' autoplay playsinline preload='metadata' class='media-preview-video'></video></div>",
			success: function(layero, index){
				var $video = $(layero).find('.media-preview-video');
				var syncLayerPosition = function(){
					var $dialog = $('#layui-layer' + index);
					if(!$dialog.length){
						return;
					}
					var viewportW = $(window).width();
					var viewportH = $(window).height();
					var maxWidth = Math.max(viewportW - 32, 280);
					var mediaNode = $video.get(0);
					var aspect = mediaNode && mediaNode.videoWidth && mediaNode.videoHeight ? mediaNode.videoWidth / mediaNode.videoHeight : (16 / 9);
					var dialogWidth = Math.min(maxWidth, 960);
					var maxContentHeight = Math.max(viewportH - 80, 240);
					if(dialogWidth / aspect > maxContentHeight){
						dialogWidth = maxContentHeight * aspect;
					}
					dialogWidth = Math.max(Math.floor(dialogWidth), Math.min(320, maxWidth));
					layer.style(index, {
						width: dialogWidth + 'px',
						top: Math.max((viewportH - $dialog.outerHeight()) / 2, 16) + 'px',
						left: Math.max((viewportW - dialogWidth) / 2, 16) + 'px'
					});
				};
				$video.on('loadedmetadata canplay', syncLayerPosition);
				syncLayerPosition();
				var videoNode = $video.get(0);
				if(videoNode && videoNode.play){
					var playResult = videoNode.play();
					if(playResult && playResult.catch){
						playResult.catch(function(){});
					}
				}
			}
		});
	};
	
	function VideoManage(){
		
	}
	var videoManage = VideoManage;
	
	videoManage.prototype.options={};
	videoManage.prototype.init=function(options){
		this.options=options;
		this._state = this._state || {
			data: {},
			dataMultiple: [],
			categoryId: 0,
			initCategories: null,
			categoryTree: null
		};
	}
	videoManage.prototype.render=function(){
		var state = this._state || (this._state = {
			data: {},
			dataMultiple: [],
			categoryId: 0,
			initCategories: null,
			categoryTree: null
		});
		var video_data = state.data || {};
		var video_data_multiple = Array.isArray(state.dataMultiple) ? state.dataMultiple : [];
		var category_id = state.categoryId || 0;
		var init_categorys = state.initCategories;
		var category_tree = state.categoryTree;
		var syncState = function(){
			state.data = video_data;
			state.dataMultiple = video_data_multiple;
			state.categoryId = category_id;
			state.initCategories = init_categorys;
			state.categoryTree = category_tree;
		};
		syncState();
		var load=layer.load();
		var videoUploadUrl=this.options.videoUploadUrl;
		var videoDelUrl=this.options.videoDelUrl;
		var videoMoveUrl=this.options.videoMoveUrl;
		var editVideoNameUrl=this.options.editVideoNameUrl;
		var videoCategory=this.options.videoCategory;
		var videoCategoryUrl=this.options.videoCategoryUrl;
		var videoCategoryUpdateUrl=this.options.videoCategoryUpdateUrl;
		var videoCategoryDelUrl=this.options.videoCategoryDelUrl;

	var multiple=this.options.multiple;
		var that;
		
		var size = this.options.size;
		var acceptMime = this.options.acceptMime;
		var headers = this.options.headers;
		var field = this.options.field;
		var exts = this.options.exts;
		var videoUploadData =this.options.videoUploadData;
		
		var videoUrl=this.options.videoUrl;
		var videoDialogOptions = getMediaDialogFormOptions();
		var video_s_time=0;
		var video_e_time=0;
		var video_total=0;
		var callback=this.options.callback;
		var videoMax=this.options.videoMax||12;
		
		var video_manage_div= this.options.elem+"_video_manage_div";
		var video_manage= this.options.elem+"_video_manage";
		var video_upload= this.options.elem+"_video_upload";
		var video_del= this.options.elem+"_video_del";
		var video_move= this.options.elem+"_video_move";
		var video_category= this.options.elem+"_video_category";
		var video_category_add=this.options.elem+"_video_category_add";
		var video_search_input=this.options.elem+"_video_search_input";
		var video_search_date=this.options.elem+"_video_search_date";
		var video_search_btn=this.options.elem+"_video_search_btn";
		var video_mobile_category_toggle=this.options.elem+"_video_mobile_category_toggle";
		var video_mobile_search_toggle=this.options.elem+"_video_mobile_search_toggle";
		var video_content=this.options.elem+"_video_content";
		var video_page=this.options.elem+"_video_page";
		var video_confirm= this.options.elem+"_video_confirm";
		var video_cancel= this.options.elem+"_video_cancel";
		var video_item=this.options.elem+"_video_item";
		var video_select_all=this.options.elem+"_video_select_all";
		var video_select_all_num=this.options.elem+"_video_select_all_num";
		var getVideoItems = function(){
			return $("#"+video_content+" a");
		};
		var getVideoItemData = function(item){
			item=$(item);
			return {
				id:item.attr('data-id'),
				path:item.attr('data-path'),
				size:item.attr('data-size'),
				title:item.find('span').text()
			};
		};
		var videoSelection = createMediaSelectionHelper({
			multiple: multiple,
			max: videoMax,
			selectClass: 'video-item-select',
			getItems: getVideoItems,
			getSelectedItems: function(){
				return video_data_multiple;
			},
			setSelectedItems: function(items){
				video_data_multiple = items;
				syncState();
			},
			getSingleSelected: function(){
				return video_data;
			},
			setSingleSelected: function(item){
				video_data = item;
				syncState();
			},
			setSelectedCount: function(count){
				$("#"+video_select_all_num).text(count);
			},
			setSelectAllChecked: function(checked){
				$("#"+video_select_all).prop('checked', checked);
			},
			getItemData: getVideoItemData,
			markSelected: function(item){
				$("#"+video_item+"_"+item.id).addClass('video-item-select');
			},
			onLimit: function(){
				layer.msg(t('maxSelect', '最多只能选{max}个', {max: videoMax}));
			}
		});
		var updateVideoSelectedCount = videoSelection.updateSelectedCount;
		var syncVideoSelectAll = videoSelection.syncSelectAll;
		var applyVideoSelections = videoSelection.applySelections;
		var setVideoItemSelected = videoSelection.setItemSelected;
		var bindVideoItems = videoSelection.bindItems;
		var syncSelectedVideosFromDom = function(){
			var selectedItems = [];
			getVideoItems().filter('.video-item-select').each(function(){
				selectedItems.push(getVideoItemData(this));
			});
			if(multiple){
				video_data_multiple = selectedItems;
			}else{
				video_data = selectedItems.length ? selectedItems[0] : {};
			}
			syncState();
		};
		var mobilePanels = null;
		var pagesize="15";
		if(videoCategory){
			var pagesize="12";
		}
		
		
		if($("#"+video_manage_div).length>0){

		}else{
			var html="";
			html=html+'<div id="'+video_manage_div+'" class="video-manage">';
			html=html+'<div id="'+video_manage+'" class="media-manage-shell" data-mobile-search="closed" data-mobile-category="closed">';
			html=html+createMediaMobileBar({
				categoryTriggerId: videoCategory ? video_mobile_category_toggle : '',
				searchTriggerId: video_mobile_search_toggle,
				categoryText: t('allVideos', '所有视频'),
				searchText: t('search', '搜索')
			});
			html=html+'<div class="media-manage-stage'+(videoCategory ? ' media-manage-body-with-side' : '')+'">';
			if(videoCategory){
				html=html+'<div class="media-manage-side video-manage-side">';
				html=html+'<h3 class="video-manage-category-title" id="'+video_category_add+'">'+t('addGroup', '添加分组')+'</h3>';
				html=html+'<div class="video-manage-left-content" id="'+video_category+'"></div>';
				html=html+'</div>';
				html=html+'<div class="video-manage-right media-manage-main">';
			}else{
				html=html+'<div class="video-manage-right media-manage-main">';
			}
			
			html=html+'<div class="video-manage-header">';
			html=html+'<label>'+t('dateRange', '日期范围')+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+video_search_date+'" >';
			html=html+'<label>'+t('fileName', '文件名')+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+video_search_input+'" >';
			html=html+'<button class="layui-btn layui-btn-sm" id="'+video_search_btn+'"><i class="layui-icon">&#xe615;</i>'+t('search', '搜索')+'</button>';
			html=html+'</div>';
			if(videoCategory){
				html=html+'<div class="video-content" id="'+video_content+'">';
			}else{
				html=html+'<div class="video-content video-content-no" id="'+video_content+'">';
			}
			html=html+'</div>';
			html=html+'<div class="video_page">';
			if(multiple){
			html=html+'<div class="video_page_left">';
			html=html+'<input type="checkbox" id="'+video_select_all+'"/><span>'+t('selectAllPage', '本页全选')+'</span><label>'+t('selectedCount', '已选 {count} 个', {count: '__COUNT__'}).replace('__COUNT__', '<span id="'+video_select_all_num+'">0</span>')+'</label>';
			html=html+'</div>';
			}
			html=html+'<div class="video_page_right" id="'+video_page+'"></div>';
			html=html+'</div>';
			html=html+'</div>';
			html=html+'</div>';
			var videoFooterActions='';
			videoFooterActions=videoFooterActions+'<a href="javascript:;" id="'+video_del+'" class="layui-btn layui-btn-sm layui-btn-danger media-manage-action media-manage-action-delete">'+t('delete', '删除')+'</a>';
			if(videoCategory){
				videoFooterActions=videoFooterActions+'<a href="javascript:;" id="'+video_move+'" class="layui-btn layui-btn-sm layui-btn-normal media-manage-action media-manage-action-move">'+t('move', '移动')+'</a>';
			}
			videoFooterActions=videoFooterActions+'<a href="javascript:;" id="'+video_upload+'" class="layui-btn layui-btn-sm layui-bg-green media-manage-action media-manage-action-upload">'+t('uploadVideo', '上传视频')+'</a>';
			html=html+createMediaDialogFooter({
				actionsHtml: videoFooterActions,
				confirmId: video_confirm,
				cancelId: video_cancel,
				confirmText: t('confirm', '确定'),
				cancelText: t('cancel', '取消')
			});
			html=html+'</div>';
			$('body').append(html);
			
			if(multiple){
				$("#"+video_select_all).click(function(){
					var checked=$(this).prop('checked');
					getVideoItems().each(function(){
						setVideoItemSelected(this, checked);
					});
				});
			}
			/*时间范围选择*/
			laydate.render({
				elem: '#'+video_search_date
				,range: true
				,done: function(value, date, endDate){
					video_s_time=Date.parse(date.year+"-"+date.month+"-"+date.date+" "+date.hours+":"+date.minutes+":"+date.seconds)/1000;
					video_e_time=Date.parse(endDate.year+"-"+endDate.month+"-"+endDate.date+" "+date.hours+":"+date.minutes+":"+date.seconds)/1000+24*60*60;
				}
			});
			if(videoCategory){
				/*移动图片*/
				$("#"+video_move).click(function(){
					var html="";
					html=html+"<form class='layui-form video-layer-form' lay-filter='"+video_manage+"_filter'>"+createMediaFormFieldHtml({label:t('selectGroup', '选择分组'),fieldHtml:"<select id='"+video_manage+"_select' class='layui-select'>"});
					html=html+(category_tree ? category_tree.buildMoveOptionsHtml() : "<option value='0'>"+t('allVideos', '所有视频')+"</option>");
					html=html+"</select></div></div></form>";
					if(multiple==false){
						var arr = Object.keys(video_data); 
						if(arr.length>0){
							layer.open({
								type: 1,
								title: t('moveVideo', '移动视频'),
								closeBtn: 1,
								shadeClose: false,
								skin: videoDialogOptions.skin,
								resize:false,
								scrollbar:false,
								area: videoDialogOptions.area,
								content: html,
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								success: function(layero, index){
									form.render('select', video_manage+'_filter');
								},
								yes:function(index, layero){
									layer.close(index);
									var load=layer.load();
									$.ajax({
										type:'post',
										dataType:'json',
										url:videoMoveUrl,
										data:{id:video_data['id'],category_id:$("#"+video_manage+'_select').val()},
				success:function(result){
					layer.close(load);
											if(result.code==0){
												layer.msg(t('moveSuccess', '移动成功'));
												$("#"+video_item+"_"+video_data['id']).remove();
												video_data={};
											}else{
												layer.msg(t('moveFailed', '移动失败'));
											}
										}
									})
								}
							})
						}else{
							layer.msg(t('selectVideoToMove', '请选择要移动的视频?'));
						}
					}else{
						if(video_data_multiple.length>0){
							layer.open({
								type: 1,
								title: t('moveVideo', '移动视频'),
								closeBtn: 1,
								shadeClose: false,
								skin: videoDialogOptions.skin,
								resize:false,
								scrollbar:false,
								area: videoDialogOptions.area,
								content: html,
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								success: function(layero, index){
									form.render('select', video_manage+'_filter');
								},
								yes:function(index, layero){
									layer.close(index);
									var load=layer.load();
									var ids=Array();
									for(let i in video_data_multiple){
										ids.push(video_data_multiple[i]['id']);
									}
									$.ajax({
										type:'post',
										dataType:'json',
										url:videoMoveUrl,
										data:{id:ids,category_id:$("#"+video_manage+'_select').val()},
										success:function(result){
											layer.close(load);
											if(result.code==0){
												layer.msg(t('moveSuccess', '移动成功'));
												for(let i in video_data_multiple){
													$("#"+video_item+"_"+video_data_multiple[i]['id']).remove();
												}
												video_data_multiple=Array();
												$("#"+video_select_all_num).text(video_data_multiple.length);
											}else{
												layer.msg(t('moveFailed', '移动失败'));
											}
										}
									})
								}
							})
						}else{
							layer.msg(t('selectVideoToMove', '请选择要移动的视频?'));
						}
					}
				});
			}
			/*删除事件*/
			$("#"+video_del).click(function(){
				if(multiple==false){
					var arr = Object.keys(video_data); 
					if(arr.length>0){
						layer.open({
							type: 1,
							title: t('deleteVideo', '删除视频'),
							closeBtn: 1,
							shadeClose: false,
							skin: videoDialogOptions.skin,
							resize:false,
							scrollbar:false,
							area: videoDialogOptions.area,
							content: createMediaConfirmHtml(t('confirmDeleteVideos', '真的要删除选择的视频吗?')),
							btn: [t('confirm', '确定'), t('cancel', '取消')],
							yes:function(index, layero){
								layer.close(index);
								var load=layer.load();
								$.ajax({
									type:'post',
									dataType:'json',
									url:videoDelUrl,
									data:{id:video_data['id']},
									success:function(result){
										layer.close(load);
										if(result.code==0){
											layer.msg(t('deleteSuccess', '删除成功'));
											$("#"+video_item+"_"+video_data['id']).remove();
											video_data={};
										}else{
											layer.msg(t('deleteFailed', '删除失败'));
										}
									}
								})
							}
						})
					}else{
						layer.msg(t('selectVideoToDelete', '请选择要删除的视频?'));
					}
				}else{
					if(video_data_multiple.length>0){
						layer.open({
							type: 1,
							title: t('deleteVideo', '删除视频'),
							closeBtn: 1,
							shadeClose: false,
							skin: videoDialogOptions.skin,
							resize:false,
							scrollbar:false,
							area: videoDialogOptions.area,
							content: createMediaConfirmHtml(t('confirmDeleteVideos', '真的要删除选择的视频吗?')),
							btn: [t('confirm', '确定'), t('cancel', '取消')],
							success: function(layero, index){
								
							},
							yes:function(index, layero){
								layer.close(index);
								var load=layer.load();
								var ids=Array();
								for(let i in video_data_multiple){
									ids.push(video_data_multiple[i]['id']);
								}
								$.ajax({
									type:'post',
									dataType:'json',
									url:videoDelUrl,
									data:{id:ids},
									success:function(result){
										layer.close(load);
										if(result.code==0){
											layer.msg(t('deleteSuccess', '删除成功'));
											for(let i in video_data_multiple){
												$("#"+video_item+"_"+video_data_multiple[i]['id']).remove();
											}
											video_data_multiple=Array();
											$("#"+video_select_all_num).text(video_data_multiple.length);
										}else{
											layer.msg(t('deleteFailed', '删除失败'));
										}
									}
								})
							}
						})
					}else{
						layer.msg(t('selectVideoToDelete', '请选择要删除的视频?'));
					}
				}
			});
			/*搜索事件*/
			$("#"+video_search_btn).click(function(data){
				uploadVideo.reload({data:{category_id:category_id}});
				var load=layer.load();
				if($("#"+video_search_date).val()==''){
					video_s_time=0;
					video_e_time=0;
				}
				$.ajax({
					type:'post',
					dataType:'json',
					url:videoUrl,
					data:{s_time:video_s_time,e_time:video_e_time,page:1,category_id:category_id,name:$("#"+video_search_input).val(),pagesize:pagesize},
					success:function(result){
						layer.close(load);
						$("#"+video_content).empty();
						var list = result.data;
						video_total=result.count;
						for(var i=0;i<list.length;i++){
							$("#"+video_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+video_item+'_'+list[i].id+"'><video src='"+escapeHtml(list[i].path)+"' controls='controls'></video><label class='video_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-search video-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
						}
						applyVideoSelections();
						bindVideoItems();
						/*编辑文件名*/
						$("#"+video_content+" a label i").off();
						$("#"+video_content+" a label i").click(function(event){
							event.stopPropagation();
							that=$(this).parent();
							if($(this).hasClass('video-preview-trigger')){
								openVideoPreview(that.parent().attr('data-path'));
							}
							if($(this).hasClass('layui-icon-edit')){
								var name=that.find('span').text();
								var tmp_id=that.attr('data');
								layer.open({
									type: 1,
									title: t('renameFile', '修改文件名【{name}】', {name: name}),
									closeBtn: 1,
									shadeClose: false,
									skin: 'layui-layer-g3ys-form',
									resize:false,
									scrollbar:false,
									area: ['470px', '230px'],
									content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
									btn: [t('confirm', '确定'), t('cancel', '取消')],
									yes:function(index, layero){
										layer.close(index);
										var tmp_val=trimText($(layero).find('input').val());
										if(tmp_val!=''){
											var load=layer.load();
											$.ajax({
												type:'post',
												dataType:'json',
												url:editVideoNameUrl,
												data:{id:tmp_id,name:tmp_val},
												success:function(result){
													layer.close(load);
													if(result.code==0){
														layer.msg(t('renameSuccess', '修改成功'));
														$(".video_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
													}else{
														layer.msg(t('renameFailed', '修改失败'));
													}
												}
											})
										}else{
											layer.msg(t('fileNameRequired', '文件名不能为空'));
										}
									}
								});
							}
						});
						laypage.render({
							elem: video_page
							,count: video_total
							,limit:15
							,jump: function(obj, first){
								if(!first){
									$("#"+video_content).empty();
									$.ajax({
										type:'post',
										dataType:'json',
										url:videoUrl,
										data:{s_time:video_s_time,e_time:video_e_time,page:obj.curr,category_id:category_id,pagesize:pagesize},
										success:function(result){
											$("#"+video_content).empty();
											var list = result.data;
											for(var i=0;i<list.length;i++){
												$("#"+video_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+video_item+"_"+list[i].id+"'><video controls='controls' src='"+escapeHtml(list[i].path)+"'></video><label class='video_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-search video-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
											}
											$("#"+video_content+" a").click(function(){
												if($(this).hasClass('video-item-select')){
													$(this).removeClass('video-item-select');
													let tmp_id=$(this).attr('data-id');
													if(multiple==false){
														video_data={};
													}else{
														for(let i in video_data_multiple){
															if(video_data_multiple[i]['id']==tmp_id){
																video_data_multiple.splice(i,1);
															}
														}
														$("#"+video_select_all_num).text(video_data_multiple.length);
													}
												}else{
													if(multiple==false){
														$("#"+video_content+" a").removeClass('video-item-select');
														video_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
													}else{
														if(video_data_multiple.length>=videoMax){
															layer.msg(t('maxSelect', '最多只能选{max}个', {max: videoMax}));
															return false;
														}else{
															var tmp_video_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
															video_data_multiple.push(tmp_video_data);
															$("#"+video_select_all_num).text(video_data_multiple.length);
															$(this).addClass('video-item-select');
														}
													}
													$(this).addClass('video-item-select');
												}
											});
											/*编辑文件名*/
										$("#"+video_content+" a label i").off();
										$("#"+video_content+" a label i").click(function(event){
											event.stopPropagation();
											that=$(this).parent();
											
											if($(this).hasClass('video-preview-trigger')){
												openVideoPreview(that.parent().attr('data-path'));
											}
											if($(this).hasClass('layui-icon-edit')){
												var name=that.find('span').text();
												var tmp_id=that.attr('data');
												layer.open({
													type: 1,
													title: t('renameFile', '修改文件名【{name}】', {name: name}),
													closeBtn: 1,
													shadeClose: false,
													skin: 'layui-layer-g3ys-form',
													resize:false,
													scrollbar:false,
													area: ['470px', '230px'],
													content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
													btn: [t('confirm', '确定'), t('cancel', '取消')],
													yes:function(index, layero){
														layer.close(index);
														var tmp_val=trimText($(layero).find('input').val());
														if(tmp_val!=''){
															var load=layer.load();
															$.ajax({
																type:'post',
																dataType:'json',
																url:editVideoNameUrl,
																data:{id:tmp_id,name:tmp_val},
																success:function(result){
																	layer.close(load);
																	if(result.code==0){
																		layer.msg(t('renameSuccess', '修改成功'));
																		$(".video_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
																	}else{
																		layer.msg(t('renameFailed', '修改失败'));
																	}
																}
															})
														}else{
															layer.msg(t('fileNameRequired', '文件名不能为空'));
														}
													}
												});
											}
										});
										}
									})
								}
							}
						});
					}
				});
				mobilePanels && mobilePanels.closeSearch();
				return false;
			});
		
		/*初始上传按钮*/
		var uploadVideo=upload.render({
			elem: '#'+video_upload
			,url: videoUploadUrl
			,field:field||'file'
			,accept:'video'
			,acceptMime:acceptMime||'video/mpeg'
			,size:size||200*1024*1024
			,headers:headers||''
			,exts:exts||'mp4'
			,data:videoUploadData||''
			,multiple:multiple
			,before:function(obj){
				layer.load();
			}
			,done: function(result){
				layer.closeAll('loading'); 
				if(result.code=='0'){
					$("#"+video_content).prepend("<a data-id='"+result.data.id+"' data-path='"+escapeHtml(result.data.path)+"' data-size='"+escapeHtml(result.data.size)+"'  id='"+video_item+'_'+result.data.id+"'><video controls='controls' src='"+escapeHtml(result.data.path)+"'></video><label class='video_item_label' data='"+result.data.id+"'><span>"+escapeHtml(result.data.name)+"</span><i class='layui-icon layui-icon-search video-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
					applyVideoSelections();
					bindVideoItems();
					/*编辑文件名*/
					$("#"+video_content+" a label i").off();
					$("#"+video_content+" a label i").click(function(event){
						event.stopPropagation();
						that=$(this).parent();
						if($(this).hasClass('video-preview-trigger')){
							openVideoPreview(that.parent().attr('data-path'));
						}
						if($(this).hasClass('layui-icon-edit')){
							var name=that.find('span').text();
							var tmp_id=that.attr('data');
							layer.open({
								type: 1,
								title: t('renameFile', '修改文件名【{name}】', {name: name}),
								closeBtn: 1,
								shadeClose: false,
								skin: 'layui-layer-g3ys-form',
								resize:false,
								scrollbar:false,
								area: ['470px', '230px'],
								content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								yes:function(index, layero){
									layer.close(index);
									var tmp_val=trimText($(layero).find('input').val());
									if(tmp_val!=''){
										var load=layer.load();
										$.ajax({
											type:'post',
											dataType:'json',
											url:editVideoNameUrl,
											data:{id:tmp_id,name:tmp_val},
											success:function(result){
												layer.close(load);
												if(result.code==0){
													layer.msg(t('renameSuccess', '修改成功'));
													$(".video_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
												}else{
													layer.msg(t('renameFailed', '修改失败'));
												}
											}
										})
									}else{
										layer.msg(t('fileNameRequired', '文件名不能为空'));
									}
								}
							});
						}
					});
					setVideoItemSelected($("#"+video_item+"_"+result.data.id), true);
				}else{
					layer.msg(result.msg);
				}
			}
		});
		if(videoCategory){
			/*添加分类*/
			$("#"+video_category_add).off();
			category_tree = createMediaCategoryTree({
				elem: "#"+video_category,
				addButton: "#"+video_category_add,
				categoryUrl: videoCategoryUrl,
				updateUrl: videoCategoryUpdateUrl,
				deleteUrl: videoCategoryDelUrl,
				allLabel: t('allVideos', '所有视频'),
				getSelectedId: function(){
					return category_id;
				},
				setSelectedId: function(value){
					category_id = value;
					syncState();
				},
				onSelect: function(){
					$("#"+video_search_btn).click();
					mobilePanels && mobilePanels.closeCategory();
				},
				texts: {
					addGroup: t('addGroup', '添加分组'),
					newGroup: t('newGroup', '新建分组'),
					groupName: t('groupName', '分组名称'),
					groupNameRequired: t('groupNameRequired', '请填写分组名称'),
					confirm: t('confirm', '确定'),
					cancel: t('cancel', '取消'),
					edit: t('edit', '修改'),
					delete: t('delete', '删除'),
					deleteGroup: t('deleteGroup', '删除分组'),
					confirmDeleteGroup: t('confirmDeleteGroup', '真的要删除该分组吗?'),
					deleteGroupWithChildren: t('deleteGroupWithChildren', '请先删除子分组'),
					renameSuccess: t('renameSuccess', '修改成功'),
					renameFailed: t('renameFailed', '修改失败'),
					deleteSuccess: t('deleteSuccess', '删除成功'),
					deleteFailed: t('deleteFailed', '删除失败')
				}
			});
			init_categorys = category_tree.reload;
			syncState();
			init_categorys();
		}
		/*获取图片*/
		$.ajax({
				type:'post',
				dataType:'json',
				url:videoUrl,
				data:{s_time:video_s_time,e_time:video_e_time,page:1,category_id:category_id,pagesize:pagesize},
				success:function(result){
					$("#"+video_content).empty();
					var list = result.data;
					video_total=result.count;
					if(list){
						for(var i=0;i<list.length;i++){
							$("#"+video_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+video_item+"_"+list[i].id+"'><video  controls='controls' src='"+escapeHtml(list[i].path)+"'></video><label class='video_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-search video-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
						}
					}
					applyVideoSelections();
					bindVideoItems();
					/*编辑文件名*/
					$("#"+video_content+" a label i").click(function(event){
						event.stopPropagation();
						that=$(this).parent();
						if($(this).hasClass('video-preview-trigger')){
							openVideoPreview(that.parent().attr('data-path'));
						}
						if($(this).hasClass('layui-icon-edit')){
							var name=that.find('span').text();
							var tmp_id=that.attr('data');
							layer.open({
								type: 1,
								title: t('renameFile', '修改文件名【{name}】', {name: name}),
								closeBtn: 1,
								shadeClose: false,
								skin: 'layui-layer-g3ys-form',
								resize:false,
								scrollbar:false,
								area: ['470px', '230px'],
								content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								yes:function(index, layero){
									layer.close(index);
									var tmp_val=trimText($(layero).find('input').val());
									if(tmp_val!=''){
										var load=layer.load();
										$.ajax({
											type:'post',
											dataType:'json',
											url:editVideoNameUrl,
											data:{id:tmp_id,name:tmp_val},
											success:function(result){
												layer.close(load);
												if(result.code==0){
													layer.msg(t('renameSuccess', '修改成功'));
													$(".video_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
												}else{
													layer.msg(t('renameFailed', '修改失败'));
												}
											}
										})
									}else{
										layer.msg(t('fileNameRequired', '文件名不能为空'));
									}
								}
							});
						}
					});

					laypage.render({
						elem: video_page
						,count: video_total
						,limit:15
						,jump: function(obj, first){

							if(!first){
								$.ajax({
									type:'post',
									dataType:'json',
									url:videoUrl,
									data:{s_time:video_s_time,e_time:video_e_time,page:obj.curr,category_id:category_id,pagesize:pagesize},
									success:function(result){
										$("#"+video_content).empty();
										var list = result.data;
										for(var i=0;i<list.length;i++){
											$("#"+video_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+video_item+"_"+list[i].id+"'><video controls='controls' src='"+escapeHtml(list[i].path)+"'></video><label class='video_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-search video-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
										}
										applyVideoSelections();
										bindVideoItems();

										/*编辑文件名*/
										$("#"+video_content+" a label i").off();
										$("#"+video_content+" a label i").click(function(event){
											event.stopPropagation();
											that=$(this).parent();
											if($(this).hasClass('video-preview-trigger')){
												openVideoPreview(that.parent().attr('data-path'));
											}
											if($(this).hasClass('layui-icon-edit')){
												var name=that.find('span').text();
												var tmp_id=that.attr('data');
												layer.open({
													type: 1,
													title: t('renameFile', '修改文件名【{name}】', {name: name}),
													closeBtn: 1,
													shadeClose: false,
													skin: 'layui-layer-g3ys-form',
													resize:false,
													scrollbar:false,
													area: ['470px', '230px'],
													content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
													btn: [t('confirm', '确定'), t('cancel', '取消')],
													yes:function(index, layero){
														layer.close(index);
														var tmp_val=trimText($(layero).find('input').val());
														if(tmp_val!=''){
															var load=layer.load();
															$.ajax({
																type:'post',
																dataType:'json',
																url:editVideoNameUrl,
																data:{id:tmp_id,name:tmp_val},
																success:function(result){
																	layer.close(load);
																	if(result.code==0){
																		layer.msg(t('renameSuccess', '修改成功'));
																		$(".video_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
																	}else{
																		layer.msg(t('renameFailed', '修改失败'));
																	}
																}
															})
														}else{
															layer.msg(t('fileNameRequired', '文件名不能为空'));
														}
													}
												});
											}
										});
									}
								})
							}
						}
					});
				}
			});
			
		}
		
		
		var layerOptions = getMediaManageLayerOptions();
		this.options.layer=layer.open({
			  type: 1,
			  title: t('selectVideo', '选择视频'),
			  closeBtn: 1,
			  shadeClose: false,
			  skin: 'layui-layer-g3ys-form-big media-manage-layer',
			  resize:false,
			  scrollbar:false,
			  area: layerOptions.area,
			  offset: layerOptions.offset,
			  content: $('#'+video_manage_div),
			  success: function(layero, index){
					mobilePanels = bindMediaMobilePanels({
						shellId: video_manage,
						categoryTriggerId: videoCategory ? video_mobile_category_toggle : '',
						searchTriggerId: video_mobile_search_toggle
					});
					bindMediaDialogFooter({
						confirmId: video_confirm,
						cancelId: video_cancel,
						onConfirm: function(){
							syncSelectedVideosFromDom();
							layer.close(index);
							if(multiple){
								if(video_data_multiple.length>0){
									for(let i in video_data_multiple){
										let item=video_data_multiple[i];
										var arr = Object.keys(item);
										(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',item['id'],item);
									}
									video_data_multiple=Array();
									$("#"+video_select_all).prop('checked',false);
									$("#"+video_content+" a").removeClass("video-item-select");
									updateVideoSelectedCount();
								}
							}else{
								var arr = Object.keys(video_data); 
								(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',video_data['id'],video_data);
								video_data={};
								$("#"+video_content+" a").removeClass("video-item-select");
							}
							$("#"+video_manage_div).hide();
						},
						onCancel: function(){
							layer.close(index);
						}
					});
					$("#"+video_manage_div).show();
					layer.close(load);
			  },
			  end:function(){
					$("#"+video_manage_div).hide();
			  }
		});
	}
	videoManage.prototype.close=function(){
		layer.close(this.options.layer);
	}
export { VideoManage as videoManage };
